import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { AuthService } from "app/core/services/auth.service";
import { RoleEnum } from "app/core/models/enum.types";

/**
 * Matches only when the current user is a Driver (and not also an admin),
 * so a driver-specific default route can take precedence over the generic one.
 */
export const driverDefaultRedirectGuard: CanMatchFn = () => {
    const authService = inject(AuthService);

    // Admins always go to the standard dashboard redirect — never the driver one.
    if (authService.isInRole([RoleEnum.SuperAdministrator, RoleEnum.Administrator])) {
        return false;
    }

    return authService.isInRole([RoleEnum.Driver]);
};
